import { RichText, RichTextValue } from "@/components/rich-text"
import { SlideOnView } from "@/components/slide-on-view"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import { cn } from "@/utils/cn"
import { SanityImageAsset, SanityReference } from "sanity-codegen"
import { Ticker } from "motion-plus/react"

interface CustomersProps {
  content: {
    variant: "default" | "crooked-blue"
    title: RichTextValue
    logos: {
      asset: SanityReference<SanityImageAsset>
    }[]
  }
}

export function Customers({ content }: CustomersProps) {
  const items = content.logos.map((logo, i) => (
    <div key={i} className="min-w-40">
      <SanityImageField className="max-h-20 w-auto" asset={logo} />
    </div>
  ))

  return (
    <div
      className={cn(
        "overflow-hidden py-15 md:py-[20vh]",
        content.variant === "default"
          ? "bg-neutral-light"
          : "bg-primary-800 text-neutral-light"
      )}
    >
      {content.variant === "crooked-blue" && (
        <Ticker
          axis="x"
          velocity={70}
          gap={80}
          hoverFactor={0.5}
          items={items}
          className="origin-center rotate-4 bg-neutral-light grayscale-100"
        />
      )}
      <SlideOnView
        className={cn(
          "w-full",
          content.variant === "default"
            ? "mx-auto mt-4 max-w-[63rem] px-6 lg:max-w-[72rem]"
            : "my-12 px-4 md:px-16 lg:px-20 xl:px-35"
        )}
      >
        <RichText value={content.title} />
      </SlideOnView>
      <Ticker
        axis="x"
        velocity={-70}
        gap={80}
        hoverFactor={0.5}
        items={items}
        className={cn(
          "grayscale-100",
          content.variant === "crooked-blue"
            ? "origin-center -rotate-4 bg-neutral-light"
            : "mt-15"
        )}
      />
    </div>
  )
}
